import { inject } from 'vue'
import { Settings } from './types/Settings'

export function getSettings (): Settings {
  const settings = inject<Settings>('vue-service:settings')

  if (!settings) {
    throw new Error('could not find the settings. Ensure it is created when the app is bootstrapped')
  }

  return settings
}
